import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-12 sm:py-24" data-id="element-84">
      <div className="mx-auto max-w-3xl px-4" data-id="element-85">
        <Reveal data-id="element-86">
          <div className="flex flex-col items-center gap-6 rounded-3xl border border-green-500/25 bg-green-500/5 p-8 text-center sm:flex-row sm:items-start sm:text-left sm:p-10" data-id="element-87">
            <span className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full border-2 border-green-500/40 bg-green-500/10 text-green-400" data-id="element-88">
              <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-89" />
            </span>
            <div data-id="element-90">
              <h2 className="font-display text-2xl text-white sm:text-3xl" data-id="element-91">
                7 Días de Satisfacción Blindada
              </h2>
              <p className="mt-3 leading-relaxed text-zinc-300" data-id="element-92">
                Prueba los GPTs. Crea tu oferta. Genera tus anuncios. Si en 7
                días no sientes que esto vale{' '}
                <span className="font-semibold text-white" data-id="element-93">10 veces</span> lo
                que pagaste, te devuelvo cada centavo. Sin preguntas. Y nos
                quedamos como amigos.{' '}
                <span className="font-semibold text-green-400" data-id="element-94">
                  El riesgo está 100% sobre mis hombros.
                </span>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}